import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { RetoPcPage } from './reto-pc';
import { ComponentsModule } from '../../../components/components.module';
// Translation
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

@NgModule({
  declarations: [
    RetoPcPage,
  ],
  imports: [
    IonicPageModule.forChild(RetoPcPage),
    ComponentsModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [ HttpClient ]
        }
    }),
  ],
})
export class RetoPcPageModule {}



// WEBPACK FOOTER //
// ./src/pages/personal-challenge/reto-pc/reto-pc.module.ts